export const sidebarWrapperHeight = 'calc(100vh - 115px)';
export const emptyArray = Object.freeze([]);
export const emptyObject = Object.freeze({});
export const emptyString = Object.freeze('');
export const emptyFunction = Object.freeze(() => {});
